// src/components/ChangePassword.js
import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Form, Button, Alert, Container } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import apiClient from '../../api/api';
import { logout } from './authSlice';

function ChangePassword() {
  const [newPassword, setNewPassword] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState(null);
  const mustChangePassword = useSelector(state => state.auth.mustChangePassword);
  const mustChangePassword2 = useSelector(state => state.mustChangePassword);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    //Optional: if user somehow gets here without needing change
    console.log("Checking if password change is required:", mustChangePassword, mustChangePassword2);
    // if (!mustChangePassword) {
    //   console.log("No need to change password, redirecting to dashboard");
    //   navigate('/dashboard');
    // }
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    setError(null);
    try {
      await apiClient.post('/auth/change-password', { new_password: newPassword });
      setStatus('succeeded');
      // Force re-login with new password (simple approach)
      dispatch(logout());
      navigate('/login');
    } catch (err) {
      setStatus('failed');
      setError(err.response?.data?.message || 'Failed to change password');
    }
  };


  return (
    <Container className="py-5">
      <h1>Change Password</h1>
      <p>You logged in with a temporary password. Please set a new password.</p>
      {error && <Alert variant="danger">{error}</Alert>}
      {status === 'succeeded' && (
        <>  
          <Alert variant="success">
            Password updated. Please log in again with your new password.
          </Alert>
          <Button as={Link} to="/login" className="ms-2 btn-corrected-path">
            Login with temporary password
          </Button>
        </>
      )}
      {(!status || status === 'idle') && (
        <> 
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>New password</Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Button type="submit" disabled={status === 'loading'}>
              {status === 'loading' ? 'Updating...' : 'Update password'}
            </Button>
          </Form>
        </>
      )}
    </Container>
  );
}

export default ChangePassword;

